import { Instagram, Mail } from "lucide-react";
import logo from "../../assets/logo-applaby.png";

export default function BlogFooter() {
	return (
		<footer className="bg-gray-50 border-t border-gray-200 mt-16">
			<div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-8 text-sm text-gray-600">
				{/* Logo + descripción */}
				<div>
					<img src={logo} alt="Applaby" className="h-8 mb-4" />
					<p>
						Plataforma para digitalizar tu negocio. Hecho para negocios que
						quieren crecer.
					</p>
				</div>

				{/* Menú rápido */}
				<div className="flex flex-col gap-2">
					<a href="/" className="hover:text-[#43bd98] transition">
						Inicio
					</a>
					<a href="/blog" className="hover:text-[#43bd98] transition">
						Blog
					</a>
					<a
						href="/terminos"
						target="_blank"
						rel="noreferrer"
						className="hover:text-[#43bd98] transition"
					>
						Términos y condiciones
					</a>
					<a
						href="/politica-privacidad"
						target="_blank"
						rel="noreferrer"
						className="hover:text-[#43bd98] transition"
					>
						Política de privacidad
					</a>
				</div>

				{/* Contacto */}
				<div className="flex flex-col gap-3">
					<a
						href="mailto:info@applaby.com"
						className="flex items-center gap-2 hover:text-[#43bd98] transition"
					>
						<Mail className="w-4 h-4" /> info@applaby.com
					</a>
					<a
						href="https://www.instagram.com/applaby_es"
						target="_blank"
						rel="noreferrer"
						className="flex items-center gap-2 hover:text-[#43bd98] transition"
					>
						<Instagram className="w-5 h-5" /> @applaby_es
					</a>
				</div>
			</div>

			<div className="border-t border-gray-200 text-center text-xs py-4 text-gray-500">
				© {new Date().getFullYear()} Applaby. Todos los derechos reservados.
			</div>
		</footer>
	);
}
